<template>
  <div class="toolbox">
    <div v-if="mode === 'all'">
      <span class="linker" @click="$emit('view','myscript')">
        <img class="tools-icon" src="../img/myscript-black.svg" alt="Draw Equation" title="Draw Equation">
      </span>
      <span class="linker" @click="$emit('view','photogallery')">
        <img class="tools-icon" src="../img/gallery-black.svg" alt="Pick from gallery" title="Pick from gallery">
      </span>
      <!-- <span v-if="!restore" class="linker" @click="restore = latex; latex = ''; onInput();">Clear</span>
      <span v-if="restore" class="linker" @click="latex = restore; onInput(); restore = false;">Restore</span> -->

      <span class="linker" @click="insertCode(); onInput();">
        <img class="tools-icon" src="../img/code-black.svg" title="Insert Code" alt="Insert Code">
      </span>
      <!-- <span class="linker" @click="insertLine(); onInput();">New Line</span> -->
      <span class="linker" @click="insertImage(); onInput();">
        <img class="tools-icon" src="../img/link-black.svg" alt="Insert Image Link" title="Insert Image Link">
      </span>
      <span class="linker" @click="insertDefault(); onInput();">
        <img class="tools-icon" src="../img/board-black.svg" alt="Sample Latex" title="Sample Latex">
      </span>
    </div>
    <div v-else-if="mode === 'math'">
      <span class="linker" @click="$emit('view','myscript')">
        <img class="tools-icon" src="../img/myscript-black.svg" alt="Draw Equation" title="Draw Equation">
      </span>
    </div>
    <textarea ref="ta" :disabled="disabled" :placeholder="placeholder" v-model="latex" class="ta" cols="30" rows="10" @change="onInput" />
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      default: false,
    },
    default: {
      default: `$$Hello$$
From \\( PALMS\\) \\(Team\\)
$$ \\sqrt2 $$
This is inline math equation \\( \\int ^{10}_{0}awesome \\)`
    },
    demoCode: {
      default: `<pre><code class="js">
var hello = {
    name: 'PALMS Team',
    msg: 'Good Morning from Hong Kong'
};
</code></pre>`
    },
    placeholder: {
      default: ``
    },
    init: {
      default: ``
    },
    mode: {
      default: `all`
    }
  },
  data() {
    return {
      addImage: (link) => `<div class="yo-latex-image-center" style="display: flex; justify-content: center; flex-wrap: wrap;">
  <div class="yo-latex-image-wrap">
    <img class="yo-latex-image" src="${link || `https://via.placeholder.com/320x320`}" style="max-width: 100%;" />
  </div>
</div>`,
      restore: false,
      latex: this.init,
      startStr: '',
      endStr: ''
    }
  },
  beforeDestroy() {
    this.onInput()
  },
  watch: {
    init () {
      this.latex = this.init
      this.$forceUpdate()
    },
    latex () {
      this.$emit('text', this.latex)
    }
  },
  methods: {
    toBottom () {
      this.$emit('inserted')
      let textarea = this.$refs['ta']
      if (textarea) {
        textarea.scrollTop = textarea.scrollHeight
        this.$nextTick(() => {
          textarea.scrollTop = textarea.scrollHeight
        })
      }
    },
    insertCode() {
      this.latex += `${this.demoCode}\n`
      this.toBottom()
    },
    insertLine() {
      if (this.startStr) {
        this.latex = `${this.startStr}\n$$$$\n${this.endStr}\n`
      } else {
        this.latex += `\n$$$$\n`
        this.toBottom()
      }
    },
    insertImage() {
      let img = window.prompt(`What's your image's link? type space to get default image`)
      if (img === ' ') {
        img = `https://via.placeholder.com/320x320`
      }
      if (img) {
        this.latex += `${this.addImage(img)}\n`
      }
      this.toBottom()
    },
    insertDefault() {
      this.latex += `${this.default}\n`
      this.toBottom()
    },
    onInput() {
      // const myField = this.$refs['ta']
      // const startPos = myField.selectionStart
      // const endPos = myField.selectionEnd
      // this.startStr = myField.value.substring(0, startPos)
      // this.endStr = myField.value.substring(endPos, myField.value.length)
      this.$emit('text', this.latex)
      // this.$emit('latex', {
      //   latex: this.latex,
      //   start: this.startStr,
      //   end: this.endStr
      // })
    }
  }
}
</script>

<style scoped>
.ta{
  width: 100%;
  height: 100%;
}

.linker {
  cursor: pointer;
  display: inline-block;
  text-decoration: underline;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: auto;
  margin-right: auto;
  padding: 3px;
}

.tools-icon{
  max-width: 24px;
  max-height: 24px;
}

.toolbox{
  width: 100%;
}
</style>
